window.renderCartRecommendations = async function (productIds) {
  // Initialize constants and variables
  const recommendations = document.getElementById('cart-recommendations');

  // Helper function to build recommendation API URLs
  const buildUrl = (id) =>
    `${window.Shopify.routes.root}recommendations/products?${new URLSearchParams(
      {
        product_id: id,
        intent: 'related',
        section_id: 'product-recommendations',
      },
    )}`;

  // Fetch recommendations for all products in parallel
  const fetchRecommendationHTML = async (productId) => {
    try {
      const response = await fetch(buildUrl(productId));
      if (!response.ok) return null;
      return await response.text();
    } catch {
      return null;
    }
  };

  const responses = await Promise.all(
    productIds.map((id) => fetchRecommendationHTML(id)),
  );

  // Parse each response into ordered arrays of product cards
  const perProductCards = [];
  for (const html of responses) {
    if (!html) {
      perProductCards.push([]);
      continue;
    }

    const container = Object.assign(document.createElement('div'), {
      innerHTML: html,
    });

    const root =
      container.querySelector(
        '.product-recommendations, #shopify-section-product-recommendations, [id*="shopify-section"][id*="product-recommendations"]',
      ) || container;

    const cards = Array.from(root.querySelectorAll('[data-product-id]')).map(
      (el) => ({
        id: el.getAttribute('data-product-id') || '',
        html: el.outerHTML,
      }),
    );

    perProductCards.push(cards);
  }

  // Interleave recommendations across products to preserve best-to-worst recommendation match order
  const combined = [];
  let maxLength = 0;
  for (const productCardList of perProductCards) {
    if (productCardList.length > maxLength) {
      maxLength = productCardList.length;
    }
  }
  for (let i = 0; i < maxLength; i++) {
    for (const list of perProductCards) {
      if (list[i]) combined.push(list[i]);
    }
  }

  // Remove duplicates, then trim to 3 items
  const seen = new Set();
  const final = [];
  for (const item of combined) {
    if (!item?.id || seen.has(item.id)) continue;
    seen.add(item.id);
    final.push(item.html);
    if (final.length >= 3) break; // Limit to 3 recommendations
  }

  // Render final recommendations or empty state
  recommendations.innerHTML = final.length
    ? `<a href="#checkout-button" class="cart-skip-link">Skip recommended products</a><h2 class="cart-recommendations-title" id="cart-recommendations-title">People also bought</h2><ul class="cart-recommendations-list">${final.join('')}</ul>`
    : '';

  // Skip link for keyboard users - jumps past the recommendations to Checkout button
  recommendations
    .querySelector('.cart-skip-link')
    ?.addEventListener('click', (event) => {
      event.preventDefault(); // Move focus without adding #checkout-button to the URL
      document.getElementById('checkout-button').focus();
    });
};

// Initialize cart recommendations on page load
document.addEventListener('DOMContentLoaded', () => {
  const recommendations = document.getElementById('cart-recommendations');
  if (!recommendations) return;

  const initialProductIds = window.cartProductIds || [];
  if (window.renderCartRecommendations) {
    window.renderCartRecommendations(initialProductIds);
  }
});

// Re-render when cart items change.
const cartEvents = ['cart:change', 'cart:updated'];

function handleCartRecommendations(event) {
  const ids = Array.isArray(event?.detail?.productIds)
    ? event.detail.productIds
    : window.cartProductIds || [];
  window.renderCartRecommendations?.(ids);
}

cartEvents.forEach((evt) =>
  document.addEventListener(evt, handleCartRecommendations),
);
